import CrowdfundingPropertyError from './CrowdfundingPropertyError';

class VolumeDiscountsError extends CrowdfundingPropertyError {
  constructor(code, details = null) {
    super(code, 'VolumeDiscountsError', details);
  }
}

export default VolumeDiscountsError;
